import { Injectable } from '@angular/core';
import { Payment } from 'src/app/models/payment';
import { PaymentMethodValidationRequest } from 'src/app/models/request/payment-method-validation-request';
import { PaymentComplianceService } from 'src/app/services/payment-compliance.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class PaymentComplianceAlertModalService {

  constructor(private readonly paymentComplianceService: PaymentComplianceService) { }

  async validatePaymentCompliance(target: any, customerCode: string, branchCode: string, salesOrg: string, condition: string, payments: Array<Payment>) {

    let request = new PaymentMethodValidationRequest();
    request.customerCode = customerCode;
    request.branchCode = branchCode;
    request.salesOrg = salesOrg;
    request.condition = condition;
    request.payments = payments;
    const result = (await this.paymentComplianceService.getPaymentMethodValidations(request).toPromise()).response;
    if (result.blockUSDCashReception) {
      await Swal.fire({
        title: '¡Atención!',
        html: `<h6>Cliente ya llegó al límite máximo permitido de $4,000.00 en 30 días calendario conforme circular BCH No.241/2016</h6>`,
        icon: 'error',
        width: '600px',
        target: target
      });
      return true;
    }

    if (result.customerKnowledgePerson) {
      await Swal.fire({
        title: '¡Atención!',
        html: `<h6>Se requiere llenado de formulario de conocimiento de cliente</h6>`,
        icon: 'info',
        width: '600px',
        target: target
      });
    }

    if (result.customerKnowledgeLegalEntity) {
      await Swal.fire({
        title: '¡Atención!',
        html: `<h6>Se requiere llenado de formulario de conocimiento de cliente</h6>`,
        icon: 'info',
        width: '600px',
        target: target
      });

    }

    if (result.cashTransactionRegistry) {
      await Swal.fire({
        title: '¡Atención!',
        html: `<h6>Se requiere llenado de Registro de Transacciones en Efectivo (RTE)</h6>`,
        icon: 'info',
        width: '600px',
        target: target
      });
    }
    return false;
  }
}
